import BottomSheet from './BottomSheet';
import { cn } from '@/lib/utils';
import type { ReachViewer } from '@/types';

/**
 * Lists the people who discovered a song (the reach). Shows the returned
 * viewers; if the true total exceeds what was returned, a trailing note tells
 * how many more.
 */
export default function UsersSheet({
  open,
  title,
  viewers,
  total,
  moreLabel,
  onClose,
}: {
  open: boolean;
  title: string;
  viewers: ReachViewer[];
  total: number;
  moreLabel: (n: number) => string;
  onClose: () => void;
}) {
  const remaining = total - viewers.length;

  return (
    <BottomSheet open={open} title={title} onClose={onClose} testid="users-sheet">
      <ul className="tw:flex tw:flex-col tw:gap-1">
        {viewers.map((v) => (
          <li
            key={v.id}
            className="tw:flex tw:items-center tw:gap-3 tw:rounded-xl tw:px-1 tw:py-2"
          >
            {v.avatar_url ? (
              <img
                src={v.avatar_url}
                alt=""
                className="tw:size-9 tw:shrink-0 tw:rounded-full tw:object-cover"
              />
            ) : (
              <span
                className={cn(
                  'tw:flex tw:size-9 tw:shrink-0 tw:items-center tw:justify-center tw:rounded-full',
                  'tw:bg-blue-primary tw:text-[12px] tw:font-semibold tw:text-white',
                )}
              >
                {(v.username ?? '?').slice(0, 2).toUpperCase()}
              </span>
            )}
            <span className="tw:truncate tw:text-[15px] tw:text-white">{v.username}</span>
          </li>
        ))}
      </ul>
      {remaining > 0 && (
        <p className="tw:mt-2 tw:px-2 tw:text-center tw:caption tw:text-grey-3">
          {moreLabel(remaining)}
        </p>
      )}
    </BottomSheet>
  );
}
